import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useMemo, useCallback } from 'react';
import { usePageLinkProps } from './hooks/usePageLinkProps.js';
import { jsx } from '@emotion/react';
import { ButtonLink } from '../ButtonLink/ButtonLink.js';
import { Button } from '../Button/Button.js';
import './hooks/usePaginationContext.js';
import './PaginationContext.js';
import '../LinkProvider/LinkProvider.js';
import '@indeed/ifl-css';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';

const PaginationPage = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    isActive,
    pageNumber,
    handlePageChange,
    setPageBtnAriaLabel,
    renderAsLink
  } = _ref;
  const sharedProps = useMemo(() => {
    const primaryOverrideButtonStyles = {
      bg: "background.action.inverse",
      ":hover:not([aria-disabled='true'])": {
        bg: "background.action.inverse.hover",
        color: "foreground.action.inverse.hover"
      },
      ":active:not([aria-disabled='true'])": {
        bg: "background.action.inverse.active",
        color: "foreground.action.inverse.active"
      }
    };
    const tertiaryOverrideButtonStyles = {
      color: "foreground.action.strong",
      ":hover:not([aria-disabled='true'])": {
        color: "foreground.action.strong.hover"
      },
      ":active:not([aria-disabled='true'])": {
        bg: "background.action.active",
        color: "foreground.action.strong.active"
      }
    };
    return {
      ["aria-current"]: isActive ? "page" : undefined,
      ["aria-label"]: setPageBtnAriaLabel(pageNumber),
      size: "sm",
      variant: isActive ? "primary" : "tertiary",
      sx: {
        fontSize: 1,
        inlineSize: "2.25rem",
        blockSize: "2.25rem",
        color: isActive ? undefined : "foreground.strong",
        ...(isActive ? primaryOverrideButtonStyles : tertiaryOverrideButtonStyles)
      },
      ref
    };
  }, [isActive, setPageBtnAriaLabel, pageNumber, ref]);
  const handleClick = useCallback(() => handlePageChange?.(pageNumber), [handlePageChange, pageNumber]);
  const pageLinkProps = usePageLinkProps({
    pageNumber,
    onClick: handleClick
  });
  return renderAsLink ? jsx(ButtonLink, _extends({}, pageLinkProps, sharedProps), pageNumber) : jsx(Button, _extends({
    type: "button"
  }, sharedProps, {
    onClick: handleClick
  }), pageNumber);
});

export { PaginationPage };
